module.exports = __webpack_public_path__ + "img/SIA.e0d290ab.svg";